import { RecapAssessment } from './RecapAssessment';

export const Surveys = {
  RecapAssessment,
};
